<template>
  <v-dialog max-width="600" v-model="dialog">
    <v-card>
      <v-card-title>
        {{ $t("projects.slideManagement.extract.title") }}
      </v-card-title>
      <v-card-text>
        <p
          class="body-1"
          v-html="$t('projects.slideManagement.extract.subtitle')"
        >
        </p>
        <v-container>
          <p v-if="slide.wholeslideimagestatus_set.length === 0" class="body-1">
           {{ $t("projects.slideManagement.extract.empty") }}
          </p>
          <v-list>
            <v-list-item-group multiple v-model="selected">
              <v-list-item
                v-for="status in slide.wholeslideimagestatus_set"
                :key="status"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      annotationClass(wsiStatus(status).annotation_class)
                        .class_name
                    }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer /><v-btn @click="$emit('hide')" text :disabled="loading"
        >
          {{ $t("button.cancel") }}
        </v-btn>
        <v-btn
          text
          @click="onClickRequest"
          :loading="loading"
          :disabled="buttonRequestDisabled"
          >
            {{ $t("button.request") }}
          </v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { FIND } from "@/store/modules/status";
import { FIND as FIND_ANNOTATION_CLASS } from "@/store/modules/annotationClass";
import { extractROIs } from "@/api/craiyon";

export default {
  props: {
    dialog: Boolean,
    slide: Object
  },
  data() {
    return {
      loading: false,
      selected: []
    };
  },
  computed: {
    ...mapGetters({
      wsiStatus: FIND,
      annotationClass: FIND_ANNOTATION_CLASS,
      token: "token"
    }),
    ...mapState({ project: state => state.project.currentProject }),
    buttonRequestDisabled() {
      return this.selected.length === 0;
    }
  },
  methods: {
    async onClickRequest() {
      this.loading = true;

      const annotationClassIds = this.selected
        .map(e => this.slide.wholeslideimagestatus_set[e])
        .map(e => this.wsiStatus(e))
        .map(e => e.annotation_class);

      await extractROIs(
        this.token,
        this.slide,
        annotationClassIds,
        this.project
      );

      this.loading = false;
      this.$emit("hide");
    }
  }
};
</script>

<style scoped></style>
